import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGetRec = gql`
  query getEdocSeriesTypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getEdocSeriesTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;

export function useGetRecLazyQuery() {
  return useLazyQuery(gqlGetRec, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectSeriesType = ({
  label = 'Τύπος Σειράς',
  name = 'seriestypeId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const sbLabel = (defaultValues as any)?.edocSeriesType?.name ?? undefined;
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={sbLabel}
      hook={useGetRecLazyQuery}
    />
  );
};

